<template lang="html">
    <div class="top-bar">
        <div class="layout-width">
            <div class="logo-wrapper">
                <LogoSvg></LogoSvg>
            </div>
            <div class="top-bar-right">
                <div class="top-bar-right-container">
                    <!-- <ns-loader
                        :toLoad="toLoad"
                        @dataFetched="onDataFetched"
                    >
                        <i slot="loader" class="el-icon-loading"></i>
                        <div slot="content">
                            <el-button
                                type="text"
                                class="history-button"
                                @click="openHistoryModal"
                            >
                                Mon Historique
                            </el-button>
                        </div>
                    </ns-loader> -->
                    <!-- | -->
                    <router-link
                        :to="{ name: 'Account' }"
                        class="user-options"
                    >
                        <i
                            class="el-icon-user-solid"
                            @click="menuSelected = ''"
                        ></i>
                    </router-link>
                </div>
            </div>
        </div>
        <el-dialog
            title="Historique de mes simulations"
            :visible.sync="displayHistoryModal"
            class="history-dialog"
            @close="closeHistoryModal"
        >
            <HistoryModal
                v-if="displayHistoryModal"
                :simulation-usages="simulationUsages"
                @close="closeHistoryModal"
            ></HistoryModal>
        </el-dialog>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import LogoSvg from './LogoSvg';
import HistoryModal from '@/components/partials/historyModal.vue';
import NsLoader from 'fundation-app-vuejs/src/components/partials/ns-vue-loaderV2.vue';
export default {
    name: 'TopBar',
    components: {
        LogoSvg,
        HistoryModal,
        NsLoader
    },

    data(){
        return {
            simulationUsages: [],
            displayHistoryModal: false
        };
    },

    computed: {
        ...mapGetters([
            'currentUser'
        ]),
        email () {
            let emailValue = this.currentUser.email ? this.currentUser.email : '';
            return window.config.use_apivalo_auth ? emailValue.replace(window.config.email_suffix, '') : emailValue;
        },
        toLoad() {
            return [
                {
                    model: 'simulationUsages',
                    name: 'simulationUsages',
                    filters: {
                        user_uid: this.currentUser.uid
                    }
                },
            ];
        },
    },

    methods: {
        onDataFetched(data) {
            this.simulationUsages = data.simulationUsages;
        },
        openHistoryModal(){
            this.displayHistoryModal = true;
        },
        closeHistoryModal(){
            this.displayHistoryModal = false;
        },
    }
};
</script>

<style lang="scss">
@import '../../../assets/styles/variables';
.alert-wrapper{
    min-height: 0px;
}
.top-bar {
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: $top-bar-height;
    box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.25);
    background: white;
    .logo-wrapper {
        display: inline-block;
        padding: 12px 20px 10px;
        width: 135px;
    }
    .top-bar-right {
        padding: 9px 20px;
        float: right;
    }
    .user-btn-txt {
        display: none;
    }
    @media screen and (min-width: $bp) {
        .user-btn-txt,
        .user-btn-ico {
            display: inline-block;
            vertical-align: middle;
        }
        .user-btn-ico {
            margin-right: 10px;
        }
    }
    .top-bar-right-container {
        display: flex;
        align-items: center;
        gap: 2rem;
    }
}
.user-popper {
    padding: 0 !important;
}
.user-options {
    color: $--color-primary;
    i {
        font-size: 25px;
        margin: 0 20px 6px 0;
    }
    i:hover {
        cursor: pointer;
    }
}
.history-dialog{
    .el-dialog{
        &__body{
            padding-top: 0;
            text-align: left !important;
            margin-left: 0;
        }
        &__header{
            margin-left: 0;
            margin-right: 0;
            padding-bottom: 0;
        }
        &__title{
            font-weight: bold;
            color: $--color-primary !important;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/partials/ui/TopBar.vue